import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { GLASS } from "@/lib/glass";
import { arrivalPending, markArrivalSeen, ARRIVAL_MS } from "@/lib/arrival";

const D = ARRIVAL_MS / 1000;

// One point of light igniting the void, shown once per session before the hero.
export default function ArrivalRitual() {
  const [show, setShow] = useState(() => arrivalPending());

  const finish = () => {
    markArrivalSeen();
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="arrival-ritual"
          aria-hidden="true"
          className="fixed inset-0 z-[200] flex items-center justify-center bg-[#030305]"
          style={{ pointerEvents: "none" }}
          initial={{ opacity: 1 }}
          animate={{ opacity: [1, 1, 1, 0] }}
          transition={{ duration: D, times: [0, 0.55, 0.78, 1], ease: GLASS.refract }}
          onAnimationComplete={finish}
        >
          <div className="relative h-0 w-0">
            {/* the bloom — a warm halo that swells and dissolves into the room */}
            <motion.span
              className="absolute left-0 top-0 block -translate-x-1/2 -translate-y-1/2 rounded-full"
              style={{
                width: 2,
                height: 2,
                background:
                  "radial-gradient(circle, rgba(255,248,232,0.95) 0%, rgba(132,223,244,0.55) 26%, rgba(132,223,244,0.12) 52%, transparent 72%)",
              }}
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: [0, 0, 0.95, 0.7], scale: [0, 0, 70, 420] }}
              transition={{ duration: D, times: [0, 0.28, 0.62, 1], ease: GLASS.bloom }}
            />
            {/* the spark — a sharp filament of white-gold at the very centre */}
            <motion.span
              className="absolute left-0 top-0 block -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#FFF8E8]"
              style={{ width: 3, height: 3, boxShadow: "0 0 14px 3px rgba(255,248,232,0.9)" }}
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: [0, 1, 1, 0], scale: [0, 1, 1.6, 0.3] }}
              transition={{ duration: D, times: [0, 0.3, 0.72, 1], ease: "easeOut" }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
